import { getRolesModId } from "./ids";
import { fetchFromSubgraph } from "./subgraph";
const MOD_CONFIG_QUERY = `
query RolesModConfig($id: ID!) {
  rolesModifier(id: $id) {
    avatar
    owner
    target
  }
}
`;
export const fetchRolesModConfig = async ({ chainId, address }, options) => {
    const { rolesModifier } = await fetchFromSubgraph({
        query: MOD_CONFIG_QUERY,
        variables: { id: getRolesModId(chainId, address) },
        operationName: "RolesModConfig",
    }, options);
    if (!rolesModifier) {
        return null;
    }
    return rolesModifier;
};
